<template>
  <div class="content">
    <div v-html="data"></div>
  </div>
</template>
<script>
export default {
  props: {
    data: String,
  },
  data() {
    return {
      // 表单数据
      form: {
      },
    };
  },
};
</script>
<style lang="scss" scoped>
.content {
  font-size: 14px;
  color: #606060;
  text-align: left;
}
</style>